import {
    StackerAPI,
    StackerActions,
    FETCH_STARTED,
    FETCH_COMPLETED,
    byID,
    without,
    fetchAndReturn,
} from "./utils/utils"
import { unique } from "utils/utils"
import { STACK_SELECTED } from "./stackApi"

// CONSTANTS
export const COMPOUNDS_FETCHED = "COMPOUNDS_FETCHED"

// API
class CompoundApi extends StackerAPI {
    path = "compound-blocks/"
}
const compoundApi = new CompoundApi()

class CompoundActions extends StackerActions {
    api = compoundApi
    reducer = "compounds"
    actionTypes = {
        fetched: COMPOUNDS_FETCHED,
    }
}

let CA = new CompoundActions()
CA.actions = { ...CA.actions }
export const compoundActions = CA.actions

// STATE
const initialState = {
    compounds: [],
    entities: {},
    fetching: [],
}

// REDUCERS
export function compoundReducer(state = initialState, action) {
    var compounds, compound, fetching
    switch (action.type) {
        case COMPOUNDS_FETCHED:
            return {
                ...state,
                compounds: unique([
                    ...state.compounds,
                    ...action.payload.map(compound => compound._sid),
                ]),
                entities: { ...state.entities, ...byID(action.payload) },
            }

        case FETCH_STARTED:
            return { ...state, fetching: [...state.fetching, action.key] }
        case FETCH_COMPLETED:
            fetching = state.fetching.filter(item => item !== action.key)
            return { ...state, fetching: fetching }

        case STACK_SELECTED:
            return initialState
        default:
            return state
    }
}

// SELECTORS
export const getCompoundEntities = state => state.compounds.entities
export const getCompounds = state => {
    if (typeof state.compounds.compounds.map !== "function") debugger
    return state.compounds.compounds.map(compoundId => state.compounds.entities[compoundId])
}

// HELPERS



// WEBPACK FOOTER //
// ./src/data/compoundApi.js